export default {
	'the-coupon': 'the coupon?',
	coupon: 'coupon',
	'add-new-coupon': 'add new coupon',
}